import {dateToString} from './utils';

export function formatAddress(item, withLocation = true) {
    let addressFull = '';

    if (!item)
        return '';

    if (withLocation && item.name && item.name !== '') {
        addressFull += item.name;
    }

    if (item.street !== '')
        addressFull += (addressFull !== '' ? ', ' : '') + item.street;

    if (item.commune && item.commune.name !== '') {
        addressFull += (addressFull !== '' ? ', ' : '') + item.commune.name;
    }

    if (item.country && item.country.name !== '' && item.country.name !== 'France') {
        addressFull += (addressFull !== '' ? ', ' : '') + item.country.name;
    }

    return addressFull;
}

export function formatDate(item) {
    let dateFull = dateToString(item.date);

    if (item.date_end)
        dateFull += (dateFull !== '' ? ' - ' : '') + dateToString(item.date_end);

    if (item.dates_comment)
        dateFull += '<small>' + (dateFull !== '' ? ', ' : '') + item.dates_comment + '</small>';

    return dateFull;
}

export function formatPages(item) {
    let pages = '';

    for (const page of item.pages) {
        pages += (pages !== '' ? ', ' : '') + page.NumPageAlbum;
    }

    return pages;
}